export const fastRocketPrimitive = {
  50: '#fceceb',
  100: '#f8cac9',
  200: '#f4a6a1',
  300: '#f0817c',
  400: '#ec5c57',
  500: '#DD1E11',
  600: '#b81a0e',
  700: '#94140a',
  800: '#700f07',
  900: '#4c0a05',
  950: '#2b0603'
};

export const fastRocketColorScheme = {
  light: {
    primary: {
      color: '#DD1E11',
      inverseColor: '#ffffff',
      hoverColor: '#4c0a05',
      activeColor: '#700f07'
    },
    highlight: {
      background: '#2b0603',
      focusBackground: '#94140a',
      color: '#ffffff',
      focusColor: '#ffffff'
    }
  },
  dark: {
    primary: {
      color: '#DD1E11',
      inverseColor: '#2b0603',
      hoverColor: '#f8cac9',
      activeColor: '#f4a6a1'
    },
    highlight: {
      background: 'rgba(250, 250, 250, .16)',
      focusBackground: 'rgba(250, 250, 250, .24)',
      color: 'rgba(255,255,255,.87)',
      focusColor: 'rgba(255,255,255,.87)'
    }
  }
};
